import { Placeholder } from 'react-bootstrap';
import Loader from 'components/global/Loader';

const Loadable = ({ signal, animation, placeholderType, children, template = 'spinner', className }) => {
  if (!signal) {
    return new Error('SIGNAL REQUIRED FOR LOADABLE');
  }

  if (signal?.value?.isLoading) {
    return (
      <Placeholder as={placeholderType || 'div'} animation={animation || 'glow'} className="mb-0">
        {/* Normal Loadable */}
        {!template && (
          <Placeholder xs={12} className={`${className} form-control-loadable`} />
        )}
        {/* Text Loadable */}
        {template === 'text' && (
          <Placeholder xs={12} as={placeholderType || 'p'} className={`${className} text-loadable`} />
        )}
        {/* Component Loadable */}
        {template === 'component' && (
          <Loader className="d-flex align-items-center justify-content-center my-40" />
        )}
        {template === 'spinner' && (
          <div className="w-100 d-flex justify-content-center text-primary my-16">
            <div className="spinner-border text-primary" role="status" />
          </div>
        )}
        {/* END CUSTOM LOADABLES */}
      </Placeholder>
    );
  }

  return (<div>{children}</div>);
};

export default Loadable;
